import { useState, useEffect, useRef, useCallback } from 'react';

/**
 * Кастомный хук useDebounce
 * @param {any} value - Значение, которое нужно дебаунсить
 * @param {number} delay - Задержка в миллисекундах
 * @returns {any} - Дебаунсенное значение
 */

export function useDebounce(value: unknown, delay: number) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}

/**
 * Хук для создания дебаунсенной версии функции
 * @param callback - Функция, которую нужно дебаунсить
 * @param delay - Задержка в миллисекундах
 * @returns Дебаунсенная функция
 */
export function useDebounceCallback(
	callback: (...args: any[]) => void,
	delay: number,
) {
	const timerRef = useRef<NodeJS.Timeout | null>(null);

	return useCallback(
		(...args: any[]) => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}

			timerRef.current = setTimeout(() => {
				callback(...args);
			}, delay);
		},
		[callback, delay],
	);
}
